import { render, staticRenderFns } from "./comSelect.vue?vue&type=template&id=67de9406&scoped=true&"
import script from "./comSelect.vue?vue&type=script&lang=js&"
export * from "./comSelect.vue?vue&type=script&lang=js&"
import style0 from "./comSelect.vue?vue&type=style&index=0&id=67de9406&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67de9406",
  null
  
)

export default component.exports